export const paymentMethodAccountDebit = 'Account Debit';
export const paymentMethodCreditCard = 'Credit Card';
export const paymentMethodEmployer = 'Employer';

const paymentMethods = [paymentMethodAccountDebit, paymentMethodCreditCard, paymentMethodEmployer];

export default paymentMethods;
